export const plansKeys = {
  all: ['plans'] as const,
  pricingTable: () => [...plansKeys.all, 'pricingTable'] as const,
}
